module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/categories/category-list/category-list.component.scss
// module id = ./libs/atenea-cms-brand/src/categories/category-list/category-list.component.scss
// module chunks = main